import React, { Component } from 'react';
import { sendJson } from '../../backend/Backend';
import {getCountries , getCountriesMap} from '../../backend/Countries';
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import de from 'date-fns/locale/de';
import { translate } from "react-i18next";
import i18n from "i18next";
import '../../css/style.css';
import '../Home.css';
import { Form, Row, Col, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';


registerLocale('de', de)


class EventAddLocation extends Component {

    constructor(props) {
        super(props);

        this.onEventAdd = this.onEventAdd.bind(this);
        this.onEventInputChange = this.onEventInputChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        //this.updateEventStatus = this.updateEventStatus.bind(this);

        this.state = {
            validated: false,
            event: this.props.detailModel
        };
    }

    onEventAdd() {
        sendJson('post', 'events/save', this.state.event).then(
            received => {
                console.log("Saved Event: " + received.id + " start:" + received.startDate);
            });
    }




    handleChange(e) {

        const { event } = this.state;

        const newEvent = {
            ...event,
            [e.target.name]: e.target.checked
        };

        console.log("event limit changed:" + JSON.stringify(newEvent));

        this.setState({
            event: newEvent
        });
    }

    onEventInputChange(obj) {
        const { name: fieldName, value: fieldValue } = obj.target;

        const { event } = this.state;

        const newEvent = {
            ...event,
            [fieldName]: fieldValue
        };

        this.props.updateModel("eventLocation", newEvent);

        this.setState({
            event: newEvent
        });

    }

    

    render() {
        const { t } = this.props;
        let lang = i18n.language;
        let countries = getCountries(lang);
        const { event: { name, locationName, street, zipcode, city, country } } = this.state;
        
        return (
            <div>
                <form className=" ml-2 mr-2 mb-2">

                    <Row>
                        <Col lg={10} md={8}>
                            <Form.Control placeholder={t("local")} className="mt-2"
                                value={locationName} name="locationName"
                                onChange={this.onEventInputChange}
                                maxLength={150}
                            />
                        </Col>
                        <Col lg={10} md={8}>
                            <Form.Control placeholder={t("strasse")}
                                value={street} name="street"
                                onChange={this.onEventInputChange} className="mt-2" 
                                maxLength={250}/>
                        </Col>
                        </Row>
                        <Row>
                        <Col lg={2} md={4}>
                            <Form.Control placeholder={t("plz")} className="mt-2"
                                value={zipcode} name="zipcode"
                                onChange={this.onEventInputChange} 
                                maxLength={10} />
                        </Col>
                        <Col lg={4} md={4} >
                            <Form.Control placeholder={t("ort")} className="mt-2"
                                value={city} name="city"
                                onChange={this.onEventInputChange}
                                maxLength={50} />
                        </Col>
                        <Col lg={4} md={4} className="mt-2">
                            <Form.Control as="select" name="country" value={country} onChange={this.onEventInputChange} >
                            {[...getCountriesMap().keys()].map((k, i) =>
                               <option key={k} value={k}>{countries[k]}</option>
                            )
                        }
                        </Form.Control>
                        </Col>
                    </Row>


                    <Row className="pb-3">
                        <Col lg={10} md={8}>
                            {(this.props.editMode) ?
                                (
                                    <OverlayTrigger
                                        key="top"
                                        placement="top"
                                        overlay={
                                            <Tooltip id={`tooltip-top`}>
                                                {t("speichern")}
                                            </Tooltip>
                                        }>
                                        <Button variant="outline-primary" onClick={() => this.props.saveEvent(this.state.event)} className="float-left mt-3" disabled={this.props.deleted}><span className="fa fa-save ">&nbsp;{t("speichern")}</span></Button>
                                    </OverlayTrigger>
                                )

                                :
                                ''
                            }
                        </Col>
                    </Row>
                </form>
            </div>
        )
    }
}

export default translate("translations")(EventAddLocation);
